import { render, staticRenderFns } from "./WhyPrivacyPage.vue?vue&type=template&id=98210ba4&scoped=true"
import script from "./WhyPrivacyPage.vue?vue&type=script&lang=js"
export * from "./WhyPrivacyPage.vue?vue&type=script&lang=js"
import style0 from "./WhyPrivacyPage.vue?vue&type=style&index=0&id=98210ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98210ba4",
  null
  
)

export default component.exports